// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

var _goTopClick = function () {
    $('.project__scrolltop').on('click', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 1200, 'easeInOutQuart');
    });
};

var openExternalLinks = function() {
    $('a[rel*=external]').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        var $button = $(this),
            href = $button.attr('href'),
            noProtocol = href.replace(/http[s]?:\/\//, '');

        setTimeout(function() {
            window.open(href);
        }, 200);
    });
};

var isValidEmail = function(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

$(function() {

    let $nav_wrap = $('.nav_main__wrap');

    $nav_wrap.on('mouseenter', function(event) {
        $(this).addClass('mouseenter');
    });

    $nav_wrap.on('mouseleave', function(event) {
        $(this).removeClass('mouseenter');
    });

    $('.js-nav_main__link--disabled').on('click', function (event) {
        return false;
    })

    _goTopClick();
    openExternalLinks();

    $('.container__inner').bigtext();
});